import { constants } from "../constants";

/* NAVIGATION */

export function closeWindow(): void {
    window.location.replace(constants.clientMainPage);
}
